// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.form-control {
  outline: none !important;
  box-shadow: none !important;
  border: 1px solid #ccc !important;
}
input.form-control:focus {
  border-color: blue !important;
}

button.btn,
input {
  width: 100%;
  max-width: 350px;
}

.img {
  width: 100%;
  max-width: 280px;
  min-width: 150px;
  margin-bottom: 40px;
}

p,
.back-btn {
  color: #999;
}

.activation-success {
  height: 100vh;
  padding-top: 80px;
}

.check img {
  width: 125px;
  height: 125px;
}`, "",{"version":3,"sources":["webpack://./libs/auth/src/lib/components/auth-action-successful/auth-action-successful.component.scss"],"names":[],"mappings":"AAEA;EACI,wBAAA;EACA,2BAAA;EACA,iCAAA;AADJ;AAGI;EACI,6BAAA;AADR;;AAKA;;EAEI,WAAA;EACA,gBAfe;AAanB;;AAKA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;;AAKA;;EAEI,WAAA;AAFJ;;AAKA;EACI,aAAA;EACA,iBAAA;AAFJ;;AAYI;EACE,YAAA;EACA,aAAA;AATN","sourcesContent":["$form_input_width: 350px;\n\ninput.form-control {\n    outline: none !important;\n    box-shadow: none !important;\n    border: 1px solid #ccc !important;\n\n    &:focus {\n        border-color: blue !important;\n    }\n}\n\nbutton.btn,\ninput {\n    width: 100%;\n    max-width: $form_input_width;\n}\n\n.img {\n    width: 100%;\n    max-width: 280px;\n    min-width: 150px;\n    margin-bottom: 40px;\n}\n\np,\n.back-btn {\n    color: #999;\n}\n\n.activation-success {\n    height: 100vh;\n    padding-top: 80px;\n    //   background-color: #eefcff;\n\n    // .password-set-form {\n    //     width: 100%;\n    //     max-width: $form_input_width;\n    // }\n}\n\n.check {\n    img {\n      width: 125px;\n      height: 125px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
